<template>
    <div v-if="loaded" class="glide bng-sport-home-banner">
        <div data-glide-el="track" class="glide__track">
            <ul class="glide__slides">
                <li v-for="img in images" :key="`${img.image}_${img.link}`" class="glide__slide">
                    <template v-if="img.link && img.link.indexOf('/') >= 0">
                        <a :href="img.link"><img :src="img.image"/></a>
                    </template>
                    <template v-else-if="img.link && img.link.indexOf('/') == -1">
                        <router-link :to="{ name: img.link }"><img :src="img.image"/></router-link>
                    </template>
                    <template v-else>
                        <img :src="img.image"/>
                    </template>
                </li>
            </ul>
        </div>
        <div v-if="slidesCount > 1" class="glide__bullets" data-glide-el="controls[nav]">
            <button v-for="i in slidesCount" :key="i" class="glide__bullet" :data-glide-dir="`=${i-1}`"></button>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

import Glide from '@glidejs/glide';

export default {
    name: 'sport-home-custom-banner',
    props: {
        elemId: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            loaded: false,
            images: null,
            slidesCount: 0
        };
    },
    async created() {
        await Vue.state.client.ensure();
        let client = Vue.state.client.get();
        this.images = client.view.banners.sportCustomBannerImages;
        this.slidesCount = this.images.length;

        this.loaded = true;

        setTimeout(() => {
            new Glide('.glide', { autoplay: 5000, hoverpause: false }).mount();
        });
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/sport-banners/sport-home-custom-banner.vue